// extracted by mini-css-extract-plugin
export default {"p":"GroupList_p__edhPT","area":"GroupList_area__zMrja","heading":"GroupList_heading__wMf+C","list":"GroupList_list__S+eDd"};